import ErrorPage, { PAGE_TYPES } from '@mindtickle/error-page';
import Loader from '@mindtickle/loader';
import PrintError from '@mindtickle/error-page/PrintError';
import { IS_DEV, isDebuggingEnabled } from '@mindtickle/utils';

import ENV from '~/config/env';
import { EXTERNAL_REMOTES, OTHER_REMOTES } from '../../other-remotes';

export const NAMESPACE = 'ui-shell';
export const APP_NAME = 'ui-shell';

// UXR cookie constants
export const UXR_COOKIE_NAME = 'uxr';

export type TErrorHandlerProps = {
  error: Error;
  message?: string;
};

const generateErrorFallback = (handler: (props: TErrorHandlerProps) => JSX.Element) => ({
  error,
  ...rest
}: TErrorHandlerProps) => {
  if (IS_DEV || isDebuggingEnabled()) {
    return <PrintError error={error} {...rest} />;
  }
  return handler({ error });
};

export const DEFAULT_ERROR_FALLBACK = generateErrorFallback(() => (
  <ErrorPage
    tryAgain={() => window.location?.reload()}
    centered={true}
    pageType={PAGE_TYPES.CLIENT_ERROR}
    showGoToHome={false}
    showLogo={false}
  />
));

export const DEFAULT_DELAYED_FALLBACK = () => <Loader type="Full" />;

export const FRAGMENT_COMPONENT = () => <></>;

export const ROUTES_NAMESPACE = ['new/ui/*', 'new/external-embed/*', 'new/embed/*'];
export const SHAREABLE_ROUTE_PREFIX_PATH = 'sh/:userInteractionId/*';

export const REMOTE_FILE = `${ENV.FEDERATION_REMOTE_FILE_NAME}.js`;

export const DYNAMIC_REMOTES = OTHER_REMOTES;

export const EXTERNAL_REMOTES_APPS = EXTERNAL_REMOTES;

export const PERFORMANCE_MEASURE_NAMES = {
  SHELL_RENDERING_COMPLETED: 'shellRenderingCompleted',
  AUTH_RENDERING_COMPLETED: 'authRenderingCompleted',
  REMOTE_APP_RENDERING_STARTED: 'remoteAppRenderingStarted',
};
